module.exports = __webpack_public_path__ + "media/mythic.c78f264b.webm";